// extracted by mini-css-extract-plugin
export default {"tooltip":"Dp-z","sharingV2":"Ep-z","sharingIconsV2":"Fp-z","links":"Gp-z","link":"Hp-z","facebookV2":"Ip-z","twitterV2":"Jp-z","pinterestV2":"Kp-z"};